import { useMemo } from 'react'

import { calcImageScale } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/utils'

const useImageScale = (image, containerWidth) => {
  const imageWidth = image?.original?.width || 0
  const imageHeight = image?.original?.height || 0

  const scale = useMemo(() => calcImageScale(containerWidth, imageWidth), [containerWidth, imageWidth])

  const scaledWidth = imageWidth * scale
  const scaledHeight = imageHeight * scale

  return { imageWidth, imageHeight, scale, scaledWidth, scaledHeight }
}

export default useImageScale
